import { render, staticRenderFns } from "./SbpImage.vue?vue&type=template&id=165b5aa7&scoped=true&"
import script from "./SbpImage.vue?vue&type=script&lang=js&"
export * from "./SbpImage.vue?vue&type=script&lang=js&"
import style0 from "./SbpImage.vue?vue&type=style&index=0&id=165b5aa7&prod&lang=scss&"
import style1 from "./SbpImage.vue?vue&type=style&index=1&id=165b5aa7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b5aa7",
  null
  
)

export default component.exports